const countryMap = {
  CH: 'Schweiz',
  LI: 'Liechtenstein',
}

export function findAddressById(addresses, id) {
  if (!id) {
    return undefined
  }

  return addresses.find(address => String(address.id) === String(id))
}

export function getAddressDisplay(address, salutationMap) {
  return {
    title: address.title ? salutationMap[address.title.toLowerCase()] : '',
    id: address.id ?? null,
    name: `${address.first_name} ${address.last_name} ${address.company}`,
    address: `${address.street} ${address.house_number}`,
    city: `${address.postcode} ${address.city}`,
    country: countryMap[address.country],
    link: null,
    disabled: false,
    is_default_for_shipping: address.is_default_for_shipping,
    is_default_for_billing: address.is_default_for_billing,
  }
}

export function getOscarAddressDisplay(address, salutationMap) {
  if (!address)
    return {}
  return {
    title: address.title ? salutationMap[address.title.toLowerCase()] : '',
    id: address.id ?? null,
    name: `${address.first_name} ${address.last_name} ${address.line3}`,
    address: `${address.line1} ${address.house_number}`,
    city: `${address.postcode} ${address.line4}`,
    country: countryMap[address.country],
    link: null,
    disabled: false,
    is_default_for_shipping: address.is_default_for_shipping,
    is_default_for_billing: address.is_default_for_billing,
  }
}

export function getAddressCheckoutFormat(address) {
  const config = useRuntimeConfig()
  return {
    first_name: address.first_name,
    last_name: address.last_name,
    line1: address.street,
    house_number: address.house_number,
    postcode: address.postcode,
    line4: address.city,
    line3: address.company,
    country: `${config.public.apiBase}/countries/${address.country}.api`,
    line2: address.additional,
    title: address.title,
    phone_number: address.phone,
  }
}
